import { FC } from "react";
import { Box, Stack } from "@mui/material";
import LatestAlbumFeatureTile from "./latestAlbumFeatureTile";
import PlayableContentFeatureTile from "./playableContentFeatureTile";
import prePlayImage from '../assets/podcast-preplay.jpeg';

type Props = {
	size: number | string;
};

const Jumbotron: FC<Props> = ({ size }) => {
	return (
		<Stack direction={{ xs: 'column', sm: 'column', md: 'column', lg: 'row' }}>
			{/* <Paper elevation={2} sx={{ width: size, height: size }}></Paper> */}
			<Box sx={{ display: { xs: 'block', sm: 'block', md: 'block', lg: 'none' }, mb: 2 }}>
				<LatestAlbumFeatureTile height={size} fullWidth />	
			</Box>
			<Box sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' }, mr: 2 }}>
				<LatestAlbumFeatureTile width={size} height={size} />	
			</Box>
			<PlayableContentFeatureTile
				height={size}
				title="The Tim Kulig Free Music Podcast"
				description="Check out the latest from Tim's podcast right here."
				caption="Powered by Podbean"
				prePlayImageUrl={prePlayImage}
			>
				<iframe
					title="The Tim Kulig Free Music Podcast"
					height="240"
					width="100%"
					style={{ border: 'none', minWidth: 'min(100%, 430px)', height: 240 }}
					data-name="pb-iframe-player"
					src="https://www.podbean.com/player-v2/?i=s4k3h-1043c21-pbblog-playlist&share=1&download=1&rtl=0&fonts=Arial&skin=1&font-color=&logo_link=episode_page&order=episodic&limit=10&filter=all&ss=a713390a017602015775e868a2cf26b0&btn-skin=7&size=315"
					loading="lazy"
					allowFullScreen={true}
				></iframe>
			</PlayableContentFeatureTile>
		</Stack>
	);
};

export default Jumbotron;